import {useEffect, useState} from 'react';

export const AppStoreProduct = () => {

    const Strings = data_value_scripts_object;
    const ProductObject = data_value_product_scripts_object;

    const [product, setProduct] = useState([]);
    const [productLoading, setProductLoading] = useState(true);
    const [buyRequestLoading, setBuyRequestLoading] = useState(false);
    const [buyRequestSent, setBuyRequestSent] = useState(false);
    const [buyRequestInputs, setBuyRequestInputs] = useState({
        your_name: '',
        your_email: '',
        phone_number: '',
        message: '',
        product_id: product.id
    });
    const [buyRequestInputsErrors, setBuyRequestInputsErrors] = useState({
        your_name: '',
        your_email: '',
        phone_number: '',
    });

    const wp_ajax_url = data_value_scripts_object.wp_ajax_url;

    const handleBuyRequestInputsChange = (fieldName, value) => {
        setBuyRequestInputs({...buyRequestInputs, [fieldName]: value,});
    };

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    }

    const buyRequestFormValidations = (form) => {
        const errors = {};
        if (!form.your_name || !form.your_name.trim()) {
            errors.your_name = __('Full name required');
        } else {
            if (form.your_name.trim().length < 3) {
                errors.your_name = __('Minimum 3 characters');
            }
        }
        if (!form.your_email || !form.your_email.trim()) {
            errors.your_email = __('Email required');
        } else {
            if (!validateEmail(form.your_email)) {
                errors.your_email = __('Must be valid email');
            }
        }
        if (!form.phone_number || !form.phone_number.trim()) {
            errors.phone_number = __('Phone number required');
        } else {
            if (form.phone_number.trim().length < 10) {
                errors.phone_number = __('Minimum 10 characters');
            }
        }
        return errors;
    }

    const jQueryInit = () => {
        setTimeout(() => {
            jQuery('.product-image-slider .owl-carousel').each(function () {
                let productImageSlider = jQuery(this).owlCarousel({
                    loop: true,
                    margin: 0,
                    autoplay: false,
                    items: 1,
                    rtl: (jQuery('html').attr('dir') === 'rtl')
                });
                jQuery('.product-image-slider-next').on('click', function () {
                    productImageSlider.trigger('prev.owl.carousel');
                });
                jQuery('.product-image-slider-prev').on('click', function () {
                    productImageSlider.trigger('next.owl.carousel');
                });
            });
        }, 200);
    }

    useEffect(() => {
        fetch(Strings.wp_ajax_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "dv-data": ProductObject.product_id,
            },
            body: new URLSearchParams({
                action: "dv_app_store_get_product_action",
                nonce: ProductObject.data_value_product_nonce,
                product_id: ProductObject.product_id,
            }),
        })
            .then(response => response.json())
            .then((res) => {
                setProductLoading(false);
                setProduct(res?.data);
                jQueryInit();
            })
            .catch(error => {
                setProductLoading(false);
                console.error("Error fetching product:", error)
            });
    }, []);

    const __ = (text = '') => {
        let translated_text = text;
        if (text && data_value_scripts_object[text]) {
            translated_text = data_value_scripts_object[text];
        }
        return translated_text;
    }

    const openBuyRequestModal = () => {
        jQuery('#requestToBuyModal').modal('show');
        setBuyRequestLoading(false);
        setBuyRequestSent(false);
        setBuyRequestInputs(
            {
                your_name: '',
                your_email: '',
                phone_number: '',
                message: '',
                product_id: product.id
            }
        )
    }

    const buyRequestInputsSubmit = (e) => {
        e.preventDefault();
        const newErrors = buyRequestFormValidations(buyRequestInputs);
        setBuyRequestInputsErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            setBuyRequestLoading(true);
            jQuery.ajax({
                type: 'POST',
                url: wp_ajax_url,
                data: {
                    action: 'dv_request_buy_action',
                    nonce: data_value_scripts_object.data_value_nonce,
                    your_name: buyRequestInputs.your_name,
                    your_email: buyRequestInputs.your_email,
                    phone_number: buyRequestInputs.phone_number,
                    message: buyRequestInputs.message,
                    product_id: product.id,
                    product_name: product.name,
                    product_image: product.image,
                    product_link: product.link,
                    product_tags: product.tags[0] || '',
                    product_categories: product.categories[0] || ''
                },
                success: (response) => {
                    setBuyRequestLoading(false);
                    setBuyRequestSent(true);
                    setBuyRequestInputs(
                        {
                            your_name: '',
                            your_email: '',
                            phone_number: '',
                            message: '',
                            product_id: product.id
                        }
                    );
                },
                error: (error) => {
                    setBuyRequestLoading(false);
                    setBuyRequestSent(true);
                    setBuyRequestInputs(
                        {
                            your_name: '',
                            your_email: '',
                            phone_number: '',
                            message: '',
                            product_id: product.id
                        }
                    );
                }
            });
        }
    };

    console.log('product', product)

    return (
        <>
            <div className="row">
                <div className="col-xxl-5 col-xl-5 col-lg-6">
                    <div className="app-product-sidebar">
                        {productLoading && <>
                            <div className="dv-placeholder" style={{height: "300px", borderRadius: "10px"}}></div>
                        </>}
                        {(!productLoading && product?.id) && <>
                            <div className="product-image-slider">
                                {product?.gallery?.length ?
                                    <>
                                        <div className="owl-carousel">
                                            {product?.gallery.map(image => <div className="product-image-slider-item"><a href={image} data-lightbox="roadtrip"><i className="fal fa-search"></i></a><img src={image}/></div>)}
                                        </div>
                                        <button className="product-image-slider-next"><i className="far fa-chevron-right"></i></button>
                                        <button className="product-image-slider-prev"><i className="far fa-chevron-left"></i></button>
                                    </>
                                    :
                                    <img src={product?.image || 'https://placehold.jp/18/ebebeb/616161/460x280.png?text=No%20Image'}/>}
                            </div>
                            <div className="mt-3">
                                {/*<div className="text-center d-flex justify-content-center align-items-center gap-3">*/}
                                {/*    <div className={`font-s-24 font-w-400 ${product.on_sale ? 'text-decoration-line-through text-secondary' : ''}`} dangerouslySetInnerHTML={{__html: product.wc_regular_price}}/>*/}
                                {/*    {product.on_sale && <div className="text-success font-s-24 font-w-400" dangerouslySetInnerHTML={{__html: product.wc_sale_price}}/>}*/}
                                {/*</div>*/}
                                <table className="table table-borderless m-0 mt-3">
                                    <tbody>
                                    <tr>
                                        <td className="font-s-14 font-w-700 text-secondary align-middle" style={{width: '120px'}}>{__('Category')}</td>
                                        <td className="font-s-14 align-middle">{product.categories.map(category => category).join(', ')}</td>
                                    </tr>
                                    <tr>
                                        <td className="font-s-14 font-w-700 text-secondary align-middle" style={{width: '120px'}}>{__('Version')}</td>
                                        <td className="align-middle">
                                            <div className="d-flex align-items-center mt-1">
                                                {product.tags.map(tag => <span className="badge text-bg-secondary font-s-14 font-w-400 me-1">{tag}</span>)}
                                            </div>
                                        </td>
                                    </tr>
                                    {(product.demo_username && product.demo_password) ?
                                        <>
                                            <tr>
                                                <td colSpan={2} className="font-s-14 font-w-700 text-secondary p-0 pt-2">
                                                    <div style={{background: '#f8f9fa', border: '1px solid #dee2e6', padding: '4px 8px', borderRadius: '7px'}}>
                                                        {__('Login Data')}
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="font-s-14 font-w-700 text-secondary pb-0 align-middle" style={{width: '120px'}}><i className="far fa-user"></i> {__('Username')}</td>
                                                <td className="font-s-14 align-middle pb-0">{product.demo_username}</td>
                                            </tr>
                                            <tr>
                                                <td className="font-s-14 font-w-700 text-secondary pt-1 align-middle" style={{width: '120px'}}><i className="far fa-key"></i> {__('Password')}</td>
                                                <td className="font-s-14 align-middle pt-1">{product.demo_password}</td>
                                            </tr>
                                        </> : null}
                                    </tbody>
                                </table>
                            </div>
                            <div className="d-flex align-items-center mt-3 gap-3">
                                <button type="button" onClick={openBuyRequestModal} className="btn btn-lg btn-primary w-100 mt-3 rounded-3"><i className="far fa-shopping-cart"></i> {__('Request to Buy')}</button>
                                {product.demo_link && <a href={product.demo_link} target="_blank" className="btn btn-lg btn-dark w-100 mt-3 rounded-3"><i className="far fa-external-link-alt"></i> {__('Live Demo')}</a>}
                            </div>
                        </>}
                    </div>
                </div>
                <div className="col-xxl-7 col-xl-7 col-lg-6">
                    <div className="app-product-content" dangerouslySetInnerHTML={{__html: product.description}}></div>
                </div>
            </div>
            <div className="modal fade" id="requestToBuyModal" tabIndex="-1" aria-labelledby="requestToBuyModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className={`${buyRequestLoading && 'modal-loading'} modal-content`}>
                        {
                            buyRequestSent ?
                                <>
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5" id="requestToBuyModalLabel">{__('Request to Buy')}</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body text-center">
                                        <svg width="114" height="83" className="animate__animated animate__fadeInDown animate__fast" viewBox="0 0 114 83" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M36.6875 25.2493C36.6875 17.0226 43.3566 10.3535 51.5833 10.3535H94.9167C103.144 10.3535 109.812 17.0226 109.812 25.2493V57.7494C109.812 65.9762 103.144 72.6452 94.9167 72.6452H51.5833C43.3566 72.6452 36.6875 65.9762 36.6875 57.7494V25.2493ZM44.8798 24.291C44.8355 24.6041 44.8125 24.924 44.8125 25.2493V57.7494C44.8125 61.489 47.8437 64.5202 51.5833 64.5202H94.9167C98.6563 64.5202 101.688 61.489 101.688 57.7494V25.2493C101.688 24.924 101.665 24.6041 101.62 24.291L78.0378 47.8737C75.3934 50.5176 71.1066 50.5176 68.4622 47.8737L44.8798 24.291ZM50.6251 18.5458L73.25 41.1706L95.8749 18.5458C95.5618 18.5015 95.2422 18.4785 94.9167 18.4785H51.5833C51.2578 18.4785 50.9382 18.5015 50.6251 18.5458Z"
                                                  fill="#0033FA"/>
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                  d="M12.3125 19.834C12.3125 17.5903 14.1314 15.7715 16.375 15.7715H24.5C26.7436 15.7715 28.5625 17.5903 28.5625 19.834C28.5625 22.0776 26.7436 23.8965 24.5 23.8965H16.375C14.1314 23.8965 12.3125 22.0776 12.3125 19.834ZM4.1875 41.5007C4.1875 39.2571 6.00636 37.4382 8.25 37.4382H24.5C26.7436 37.4382 28.5625 39.2571 28.5625 41.5007C28.5625 43.7442 26.7436 45.5632 24.5 45.5632H8.25C6.00636 45.5632 4.1875 43.7442 4.1875 41.5007ZM12.3125 63.1673C12.3125 60.9237 14.1314 59.1048 16.375 59.1048H24.5C26.7436 59.1048 28.5625 60.9237 28.5625 63.1673C28.5625 65.4109 26.7436 67.2298 24.5 67.2298H16.375C14.1314 67.2298 12.3125 65.4109 12.3125 63.1673Z"
                                                  fill="#00BBB8"/>
                                        </svg>
                                        <h3 className="animate__animated animate__fadeInUp animate__fast">{__('Buy Request Sent')}</h3>
                                        <p className="animate__animated animate__fadeInUp animate__fast">{__('One of our representatives will contact you within 6–8 business hours.')}</p>
                                    </div>
                                </>
                                :
                                <form method="post" action={wp_ajax_url} onSubmit={buyRequestInputsSubmit}>
                                    <input type="hidden" name="product_name" value={product.name}/>
                                    <input type="hidden" name="product_tags" value={product.tags}/>
                                    <input type="hidden" name="product_categories" value={product.categories}/>
                                    <input type="hidden" name="product_image" value={product.image}/>
                                    <input type="hidden" name="product_link" value={product.link}/>
                                    <div className="modal-header">
                                        <h1 className="modal-title fs-5" id="requestToBuyModalLabel">{__('Request to Buy')}</h1>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                    </div>
                                    <div className="modal-body">
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label htmlFor="buy-request-your_name" className="form-label">{__('Your Name')}</label>
                                                <input type="text"
                                                       className={`form-control ${buyRequestInputsErrors.your_name ? 'is-invalid' : ''}`}
                                                       onChange={e => handleBuyRequestInputsChange('your_name', e.target.value)}
                                                       value={buyRequestInputs.your_name}
                                                       name="your_name" id="buy-request-your_name" required/>
                                                <div className="invalid-feedback">{buyRequestInputsErrors.your_name}</div>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="buy-request-your_email" className="form-label">{__('Email')}</label>
                                                <input type="email" className={`form-control ${buyRequestInputsErrors.your_email ? 'is-invalid' : ''}`}
                                                       onChange={e => handleBuyRequestInputsChange('your_email', e.target.value)}
                                                       value={buyRequestInputs.your_email}
                                                       name="your_email" id="buy-request-your_email" required/>
                                                <div className="invalid-feedback">{buyRequestInputsErrors.your_email}</div>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="buy-request-phone_number" className="form-label">{__('Phone Number')}</label>
                                                <input type="text" className={`form-control ${buyRequestInputsErrors.phone_number ? 'is-invalid' : ''}`}
                                                       onChange={e => handleBuyRequestInputsChange('phone_number', e.target.value)}
                                                       value={buyRequestInputs.phone_number}
                                                       name="phone_number" id="buy-request-phone_number" required/>
                                                <div className="invalid-feedback">{buyRequestInputsErrors.phone_number}</div>
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="buy-request-product_id" className="form-label">{__('Product')}</label>
                                                <select className="form-control"
                                                        onChange={e => handleBuyRequestInputsChange('product_id', e.target.value)}
                                                        value={buyRequestInputs.product_id}
                                                        name="product_id" id="buy-request-product_id" disabled>
                                                    <option selected value={product.id}>{product.name}</option>
                                                </select>
                                            </div>
                                            <div className="col-md-12">
                                                <label htmlFor="buy-request-message" className="form-label">{__('Message')}</label>
                                                <textarea rows="3" className="form-control"
                                                          onChange={e => handleBuyRequestInputsChange('message', e.target.value)}
                                                          value={buyRequestInputs.message}
                                                          name="message" id="buy-request-message"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="submit" className="btn btn-primary" disabled={buyRequestLoading}>{buyRequestLoading ? __('Sending...') : __('Send Request')}</button>
                                    </div>
                                </form>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}